import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../commons/modal/modal';
import styles from './styles.scss';
import FileCard from '../FileCard';
import Button from '../../../../commons/Button';
import withFileUpload from '../UploadFile';
import { useUploadTanNumber } from '../../api/uploadTanSheet';
import { useDownloadTanNumberTemplate } from '../../api/downloadTemplate';

const FileUpload = withFileUpload(FileCard);

const UploadTanModal = ({ open = true, closeModal, initCall }) => {
  const [file, setFile] = useState(null);
  const { isLoading, uploadTanNumber } = useUploadTanNumber();
  const {
    downloadTanNumberTemplate,
    isLoading: templateDownloading
  } = useDownloadTanNumberTemplate();
  const uploadRef = useRef();

  const onRemove = () => {
    setFile(null);
    if (uploadRef.current) {
      uploadRef.current.reset();
    }
  };

  const onSubmit = () => {
    uploadTanNumber(file, {
      onSuccess: () => {
        initCall();
        onClose();
      }
    });
  };

  const onClose = () => {
    setFile(null);
    closeModal();
  };

  return (
    <Modal
      closeModal={onClose}
      showModal={open}
      title={<div className={styles.title}>Upload TAN Number</div>}
      minWidth="35%"
    >
      <div className={styles.wrapper}>
        <div className={styles.modalBody}>
          <FileCard
            title="Download Templete"
            csx={{ wrapper: { flexBasis: '48%' } }}
            isRemove={templateDownloading}
            onClick={downloadTanNumberTemplate}
          >
            <>{templateDownloading && <div>Downloading...</div>}</>
          </FileCard>
          <FileUpload
            ref={uploadRef}
            isUpload
            title="Upload Excel File"
            csx={{
              wrapper: {
                flexBasis: '48%'
              },
              root: {
                ...(file && { borderColor: '#dd712f' })
              }
            }}
            onFileSelect={file => {
              setFile(file);
            }}
            onRemoveClick={onRemove}
            isRemove={!!file}
          >
            <div
              style={{
                wordBreak: 'break-all',
                wordWrap: 'break-word'
              }}
            >
              {file && file.name}
            </div>
          </FileUpload>
        </div>

        <div className={`${styles.btnWrapper}`}>
          <Button
            text="Submit"
            className={styles.submitBtn}
            disabled={!!!file || isLoading}
            loading={isLoading}
            onClick={onSubmit}
          />
        </div>
      </div>
    </Modal>
  );
};

UploadTanModal.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  initCall: PropTypes.func.isRequired
};

export default UploadTanModal;
